import { render, staticRenderFns } from "./Dreams.vue?vue&type=template&id=3696b8f7&scoped=true"
import script from "./Dreams.vue?vue&type=script&lang=js"
export * from "./Dreams.vue?vue&type=script&lang=js"
import style0 from "./Dreams.vue?vue&type=style&index=0&id=3696b8f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3696b8f7",
  null
  
)

export default component.exports